import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navLinks = [
  { path: '/', label: '首页' },
  { path: '/category/dianshiju', label: '分类' },
  { path: '/about', label: '关于我们' },
];

const mobileMenuLinks = [
  { path: '/', label: '首页', icon: 'ri-home-4-line' },
  { path: '/category/dianshiju', label: '分类浏览', icon: 'ri-grid-line' },
  { path: '/about', label: '关于我们', icon: 'ri-information-line' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileMenuOpen(false);
  }, [location.pathname]);

  return (
    <>
      <nav
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
          scrolled
            ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
            : 'bg-transparent'
        }`}
      >
        <div className="w-full px-4 md:px-6">
          <div className="flex items-center justify-between h-16">
            <Link
              to="/"
              className="flex items-center gap-2 no-underline group"
            >
              <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500">
                <i className="ri-play-circle-fill text-xl text-background-50"></i>
              </div>
              <span className="text-lg font-bold text-foreground-950 font-heading whitespace-nowrap">
                蘑菇视频
              </span>
            </Link>

            <div className="hidden md:flex items-center gap-8">
              {navLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  className={`text-sm font-medium transition-colors duration-200 whitespace-nowrap ${
                    location.pathname === link.path
                      ? 'text-primary-500'
                      : 'text-foreground-700 hover:text-primary-500'
                  }`}
                >
                  {link.label}
                </Link>
              ))}
            </div>

            <div className="hidden md:flex items-center gap-3">
              <a
                href="#"
                className="flex items-center gap-1.5 px-4 py-2 rounded-full text-sm font-medium text-foreground-700 bg-background-100 hover:bg-background-200 transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-search-line"></i>
                <span>搜索</span>
              </a>
              <Link
                to="/about"
                className="flex items-center gap-1.5 px-5 py-2 rounded-full text-sm font-medium text-background-50 bg-primary-500 hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                开始观看
              </Link>
            </div>

            <button
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              className="md:hidden w-10 h-10 flex items-center justify-center rounded-lg text-foreground-700 hover:bg-background-100 transition-colors cursor-pointer"
              aria-label="打开菜单"
            >
              <i className={`text-xl ${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
            </button>
          </div>
        </div>
      </nav>

      <div
        className={`fixed inset-0 z-40 md:hidden transition-opacity duration-300 ${
          mobileMenuOpen ? 'opacity-100 pointer-events-auto' : 'opacity-0 pointer-events-none'
        }`}
        onClick={() => setMobileMenuOpen(false)}
      >
        <div className="absolute inset-0 bg-black/30 backdrop-blur-sm"></div>
        <div
          className="absolute top-0 left-0 right-0 bg-background-50 pt-20 pb-8 px-6 rounded-b-2xl"
          onClick={(e) => e.stopPropagation()}
        >
          <div className="flex flex-col gap-1">
            {mobileMenuLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`flex items-center gap-3 px-4 py-3 rounded-lg text-base font-medium transition-colors duration-200 ${
                  location.pathname === link.path
                    ? 'bg-primary-50 text-primary-600'
                    : 'text-foreground-700 hover:bg-background-100'
                }`}
              >
                <i className={`${link.icon} text-lg`}></i>
                {link.label}
              </Link>
            ))}
          </div>
          <div className="mt-6 flex flex-col gap-3">
            <a
              href="#"
              className="flex items-center justify-center gap-2 px-4 py-3 rounded-full text-sm font-medium text-foreground-700 bg-background-100 hover:bg-background-200 transition-colors cursor-pointer"
            >
              <i className="ri-search-line"></i>
              搜索视频
            </a>
            <Link
              to="/about"
              className="flex items-center justify-center gap-2 px-4 py-3 rounded-full text-sm font-medium text-background-50 bg-primary-500 hover:bg-primary-600 transition-colors cursor-pointer"
            >
              开始观看
            </Link>
          </div>
        </div>
      </div>
    </>
  );
}